import { ReactElement, useContext, useEffect } from "react";
import { pageNames } from "../../authConfig";
import { ApplicationLocationContext } from "../../utils/ApplicationState";
import ReportPage from "./ReportPage";

export const Reports = (): ReactElement => {
  const { setState } = useContext(ApplicationLocationContext);

  useEffect(() => {
    setState({ path: [pageNames.reports] });
  }, [setState]);

  return (
      <ReportPage></ReportPage>
  );
};
